import EntityList from './EntityList';

export default EntityList;
